module.exports = __webpack_public_path__ + "images/icon/common_ic_remove_block_hover-e7dd2dc2.svg";